<div class="container">
    <h1 class="mt120">{{bookdetails.bookHeading}}</h1>
    <hr class="mb-0" />
</div>

<div class="mainContnet">
    <div class="container">
        <p>{{bookdetails.bookDescription}}</p>
        
        <div class="row mt-5">
            <div class="col-sm-12 col-md-6 col-lg-4">
                <div class="mx-auto d-table">
                    <figure class="book">
                        <img [src]="bookdetails.bookImageURl" class="img-fluid" width="185" height="279" />
                        <figcaption>Libro Alumno</figcaption>
                    </figure>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4">
                <div class="btnCenter">
                    <h2 class="text-center">Libro Alumno</h2>
                    <a *ngIf="bookdetails.isEnrollOnline" href="{{bookdetails.enrollOnlineLink}}" class="btn btnSecondary mt-2">Enroll Online</a>
                    <a *ngIf="bookdetails.isBuyHardCopy" href="{{bookdetails.buyHardCopyLink}}" class="btn btnSecondary mt-2">Comprar copia impresa</a>
                    <a *ngIf="bookdetails.isSamplePDF" href="{{bookdetails.samplePDFLink}}" class="btn btnSecondary mt-2">Muestra de PDF</a>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4">
                <div class="mx-auto d-table">
                    <h2 class="text-center">Guía de Líderes</h2>
                    <a *ngIf="bookdetails.isLeaderGuideHardCopy" href="{{bookdetails.leaderBuyHardCopyLink}}" class="btn btnSecondary mt-2">Comprar copia impresa</a>
                    <a *ngIf="bookdetails.isLeaderGuideSmaplePDF" href="{{bookdetails.leaderSamplePDFlink}}" class="btn btnSecondary mt-5">Muestra de PDF</a>
                    <p *ngIf="bookdetails.isLeaderGuidButton" class="has-text-align-center">Guía para los líderes no está disponible . Si se prepara una guía del líder bien escrito , podemos hacer que esté disponible aquí , para el beneficio de otros. &nbsp;<a class="mailto" href="mailto:itim@TrainingInMinistry.com?Subject=Leaders%20Guide" target="_top" rel="noopener noreferrer">Contáctenos</a> para más información.</p>
                </div>
            </div>
        </div>

        <div class="mt-5">
            <p class="note"><strong>Nota: </strong>{{bookdetails.note}}</p>
        </div>

    </div>
</div>